import GermanFlag from "../images/de.svg";
import USFlag from "../images/us_flag.svg";
import FranceFlag from "../images/fr_flag.svg";
import SpainFlag from "../images/es_flag.svg";
const CountryFlag = ({ countryCode }) => {
  const Flag = ({ code, className }) => {
    switch (code) {
      case "DE":
        return <img src={GermanFlag} alt="German Flag" className={className} />;
      case "US":
        return <img src={USFlag} alt="US Flag" className={className} />;
      case "FR":
        return <img src={FranceFlag} alt="France Flag" className={className} />;
      case "ES":
        return <img src={SpainFlag} alt="Spain Flag" className={className} />;
      default:
        return null;
    }
  };
  return (
    <div>
      <Flag
        code={countryCode}
        className="w-10 h-10 rounded-full object-cover object-center"
      />
    </div>
  );
};
export default CountryFlag;
